export default __webpack_public_path__ + "static/media/leavebottombottom.1473a400.svg";